export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const jobLink = (token) => `${window.location.origin}/v/${token}`;

export const buildMessage = (d) => {
  const tasks = (d.tasks || []).slice(0, 2).map((t) => `• ${t}`).join("\n");
  return `⚡ Job from ${d.sender_name || "DropIt"}: ${d.title || d.task_summary}\n${tasks}${tasks ? "\n" : ""}Open job map & details: ${jobLink(d.job_token)}`;
};

export const channelHrefs = (d, phone, email) => {
  const enc = encodeURIComponent(buildMessage(d));
  const out = { copy: jobLink(d.job_token) };
  if (phone) {
    out.sms = isIOS() ? `sms:${phone}&body=${enc}` : `sms:${phone}?body=${enc}`;
    out.whatsapp = `https://wa.me/${phone.replace(/\D/g, "")}?text=${enc}`;
  }
  if (email) out.email = `mailto:${email}?subject=${encodeURIComponent(d.title || "Job")}&body=${enc}`;
  return out;
};

export const maskPhone = (p) => (p ? p.replace(/^(\+?\d{3})\d+(\d{3})$/, "$1•••••$2") : "");

export const relTime = (iso) => {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
